import React from 'react';
import { bool } from 'prop-types';
import styled, { keyframes } from 'styled-components';

const Shine = keyframes`
  to {
    background-position:
      100% 0, /* move highlight to right */
      0 0,
      0 40px,
      0 80px,
      0 120px;
  }
`;

const Skeleton = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 100%;
    margin-bottom: 18px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  @media (min-width: 1366px) {
    margin: 0 32px 32px 0;
    height: 100%;
    &:nth-child(4n) {
      margin-right: 32px;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
`;

const ImgMock = styled.div`
  animation: ${Shine} 1.5s infinite ease-in-out;
  background-color: rgba(211, 211, 211, 0.3);
  background-image: linear-gradient(
    120deg,
    #f7f9fd,
    rgba(255, 255, 255, 0) 50%,
    #f7f9fd 80%
  );
  background-size: 20px 200px, /* highlight */ 70% 200px, 80% 200px, 90% 200px,
    100% 200px;
  background-position: 0 0, /* highlight */ 0 0, 0 40px, 0 80px, 0 120px;
  height: 320px;
  width: 100%;
`;

const ProjectSkeleton = () => (
  <Skeleton>
    <ImgMock />
  </Skeleton>
);

export default ProjectSkeleton;
